<div class="d-flex header">
  <button class="back-button" nbButton status="primary" ghost (click)="backToEvents()">
    <mat-icon>chevron_left</mat-icon>
    Back
  </button>
</div>
